<template>
  <div class="feedback-modal">
    <div class="feedback-content">
      <div class="feedback-header">
        <button class="close" v-if="isClosable" @click="closeModal">X</button>
      </div>

      <div v-if="defaultLoadingState">
        <img src="../../public/img/loading.svg" class="loading-img" />
        <p class="message message-primary">Aguarde!</p>
        <p class="message message-secondary">Estamos analisando sua imagem.</p>
      </div>

      <div v-else-if="hasFailed">
        <img src="../../public/img/error.svg" class="error-img" />
          <p class="message message-primary">
            {{ showErrorIndicator ? "Ops!" : "" }}
          </p>
          <p class="message message-secondary">{{ message }}</p>
          <button class="error-btn" @click="onTryAgain" v-if="canTryAgain">
            Tentar novamente
          </button>
          <button class="error-btn close" @click="closeModal" v-else>
            Fechar
          </button>
      </div>

      <div v-else>
        <img src="../../public/img/check.gif" class="success-img" v-if="type !== 'reception'" />
        <img src="../../public/img/reception-success.svg" class="success-img" v-else/>
        <p class="message message-primary">Sucesso!</p>
        <p class="message success-message">
          {{ messageFeedback }}
        </p>
        <p v-if="isNameValid">{{ welcomeMessage }}</p>
        <div class="footer-container">
          <button class="home-btn" @click="redirectToHome">
            Voltar para o início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "isLoading",
    "isSuccess",
    "message",
    "attempts",
    "isNonScheduled",
    "type",
    "name",
  ],
  emits: ["onClose", "onSave", "onTryAgain"],
  methods: {
    closeModal() {
      this.$emit("onClose");
    },
    onTryAgain() {
      this.$emit("onTryAgain");
    },
    redirectToHome() {
      return this.$router.push({ name: "home" });
    },
  },
  computed: {
    hasFailed() {
      return this.isSuccess === false;
    },
    defaultLoadingState() {
      return this.isSuccess === null;
    },
    canTryAgain() {
      return this.attempts > 0;
    },
    isNonScheduledVisitorFeedback() {
      return this.isNonScheduled;
    },
    isNameValid() {
      return this.name && this.name !== "";
    },
    messageFeedback() {
      return this.type === "reception" || this.isNonScheduledVisitorFeedback
        ? "O(a) funcionário(a) já foi notificado(a). Por favor, aguarde na recepção; ele(a) virá ao seu encontro."
        : "Fechadura Liberada.";
    },
    welcomeMessage() {
      return this.name ? `Seja bem-vindo(a), ${this.name}!` : "";
    },
    isClosable() {
      return !this.defaultLoadingState && !this.hasFailed;
    },
    showErrorIndicator() {
      return this.attempts > 0 && !this.isNonScheduledVisitorFeedback;
    },

  },
};
</script>
<style scoped>
.feedback-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.feedback-content {
  background-color: #ffffff;
  padding: 30px;
  border-radius: 10px;
  text-align: center;
  width: 45vw;
  max-width: 700px;
  /* height: 60vh; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.feedback-header {
  display: flex;
  width: 100%;
  justify-content: flex-end;

  button {
    background-color: transparent;
    color: #727272;
    font-size: 16px;
    padding: 0;
    border: none;
    cursor: pointer;
    text-align: end;
  }
}

button {
  border: none;
  cursor: pointer;
  font-weight: 600;
}

.close {
  width: 130px;
  font-size: 14px;
}

img {
  width: 200px;
  height: 200px;
  /* margin-bottom: 0px; */
}

p {
  margin: 0 auto;
  line-height: 1.5;
  font-size: 16px;
  color: rgb(68, 68, 68);
}

.loading-img {
  animation: bounce 1.5s ease-in-out infinite;
}

.success-img {
  animation: fadeIn 1s ease-in-out;
}

.footer-container{
  display: flex;
  justify-content: center;
  gap: 10px;
  width: 100%;
}

.error-btn {
  padding: 10px 20px;
  color: white;
  background: linear-gradient(270deg, #EF7F55 0%, #E15550 100%);
  border-radius: 4px;
  margin-top: 20px;
  font-weight: 400;
  font-size: 16px;
}

.error-btn:hover {
  background-color: rgb(179, 40, 40);
  transition: all 0.3s ease-in-out;
}

.home-btn {
  padding: 10px 15px;
  color: #e76752;
  border-radius: 8px;
  margin-top: 20px;
  font-weight: 500;
  background-color: transparent;
}

.home-btn:hover {
  background-color: #e76752;
  color: white;
  transition: all 0.3s ease-in-out;
}

.message {
  width: 70%;
  text-align: center;
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  text-overflow: clip;
}

.message-primary {
  font-size: 18px;
  color: #333333;
  font-weight: 500;
}

.message-secondary {
  /* font-size: 14px; */
  color: #838383;
  margin-top: 3px;
}

.success-message {
  margin-top: 8px;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }
  60% {
    opacity: 1;
    transform: scale(1.2) rotate(360deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
